<!-- components/RechargeInstructions.vue -->
<template>
    <section class="recharge-instructions">
      <h4>五、充值说明</h4>
  
      <!-- 积分充值 -->
      <section class="recharge-section">
        <h4>💳 积分充值</h4>
        <ul>
          <li>用途：查询、红包</li>
          <li>比例：1U=5积分</li>
          <li>活动：多买多送</li>
        </ul>
      </section>
  
      <!-- 会员充值 -->
      <section class="recharge-section">
        <h4>🔑 会员充值</h4>
        <ul>
          <li>周费：20U</li>
          <li>月费：50U</li>
          <li>季费：100U</li>
          <li>年费：300U</li>
          <li>终身：500U</li>
        </ul>
      </section>
  
     
    </section>
  </template>
  
  <script>
  export default {
    name: 'RechargeInstructions'
  }
  </script>
  
  <style scoped>
  .recharge-section {
    margin-bottom: 1.5em;
    padding: 15px;
    background: #fffbeb;
    border-radius: 8px;
    border: 1px solid #f59e0b;
  }
  </style>